import {Component} from 'preact';
import ProductImage from '@components/common/ProductImage';
import LineItem, {Wrapper, Figure, Body, TitleLink, Sku, QtyField, PriceDisplay, PriceLine, Footer} from '../index';
import {toProductUrl} from '@util/URLUtils';

const LineItemNonEditable = props =>
    <LineItem {...props}>
        {( {id, sku, product, quantity, isLogged, displayPrice, priceRestricted} ) => (
            <Wrapper id={id}>
                <Figure>
                    <ProductImage {...product} width="90"/>
                </Figure>
                <Body>
                    <TitleLink href={toProductUrl( {path: product.url, sku} )}>{product.kitName}</TitleLink>
                    <Sku sku={sku}/>
                    <PriceLine>
                        <QtyField>{quantity}</QtyField>
                        <PriceDisplay price={displayPrice}
                                      isLogged={isLogged}
                                      priceRestricted={priceRestricted}/>
                    </PriceLine>
                </Body>
                <Footer/>
            </Wrapper>
        )}
    </LineItem>;

export default LineItemNonEditable;

